// extracted by mini-css-extract-plugin
export default {"container":"Uo-z","bubbleNav":"Vo-z","graphic":"Wo-z","contact":"Xo-z"};